import { Method } from 'axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class AddAlbumItemsAPICall extends APICallV4 {
    _method = 'album/elements/add';
    _type: Method = 'post';
}
